module.exports = __webpack_public_path__ + "static/media/appstore.5d00a7db.svg";